import { j as o } from "../../jsx-runtime-C5mzlN2N.js";
import { Fragment as e } from "react";
import { useQueryMutationHandler as n } from "./hooks.es.js";
const a = (t) => {
  const {
    queryClient: r
  } = t;
  return n({
    queryClient: r
  }), /* @__PURE__ */ o.jsx(e, {});
};
export {
  a as default,
  n as useQueryMutationHandler
};
